<template>
  <div>
    <Multiselect
      class="multiselect-custom-input"
      v-model="value"
      mode="single"
      :close-on-select="true"
      :searchable="true"
      :options="options"
      :loading="loading"
      :placeholder="$t('Select')"
      :required="required"
    />
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect';

export default {
  props: ['modelValue', 'id_company', 'required'],
  emits: ['onChange'],
  components: {
    Multiselect
  },
  watch: {
    modelValue() {
      this.value = this.modelValue;
    },
    value() {
      const brand = this.options.find((option) => String(option.value) === String(this.value));
      this.$emit('onChange', this.value, brand);
    }
  },
  mounted() {
    this.getOptions();
  },
  methods: {
    getOptions() {
      this.loading = true;
      this.$api
        .get('api/brand')
        .then((res) => {
          this.loading = false;
          this.options = res.data.map((b) => {
            return { value: b.id, label: b.name, settings: b.settings || {} };
          });
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    }
  },
  data() {
    return {
      loading: false,
      value: null,
      options: []
    };
  }
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
